// prosemirror-history does not export its plugin key
export var pmHistoryPluginKey = 'history$';
//# sourceMappingURL=pm-history-types.js.map